import React from 'react';
import { ShieldCheck, Award, Zap, HeartPulse, Sparkles, ArrowRight, CheckCircle2 } from 'lucide-react';

interface NutritionHighlightProps {
  onShopNow: () => void;
}

export const NutritionHighlight: React.FC<NutritionHighlightProps> = ({ onShopNow }) => {
  return (
    <section id="nutrition-highlight-section" className="py-6 sm:py-8 bg-slate-50 border-y border-slate-200/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-r from-[#12134a] via-[#191975] to-[#141552] text-white rounded-2xl p-5 sm:p-7 shadow-lg border border-indigo-900/40 overflow-hidden">
          
          {/* Header Row */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-5 border-b border-white/10">
            <div>
              <div className="inline-flex items-center gap-1.5 text-amber-300 text-[11px] font-extrabold uppercase tracking-wider mb-1">
                <Award className="w-3.5 h-3.5" />
                <span>MalRich Nutrition Science • 100% Halal & Lab Tested</span>
              </div>
              <h2 className="text-lg sm:text-xl md:text-2xl font-black text-white tracking-tight">
                Balanced Daily Nutrition for Natural Weight Gain & Energy
              </h2>
              <p className="text-xs text-slate-300 mt-0.5 max-w-2xl">
                Enriched with premium milk proteins, essential multivitamins & active minerals to naturally enhance appetite and strengthen daily vitality.
              </p>
            </div>

            <button
              id="nutrition-cta-btn"
              onClick={onShopNow}
              className="self-start md:self-center shrink-0 bg-amber-400 hover:bg-amber-300 text-slate-950 font-black text-xs px-5 py-2.5 rounded-xl uppercase tracking-wider flex items-center gap-1.5 shadow-md transition-all active:scale-[0.98] cursor-pointer"
            >
              <span>Explore Flavors</span>
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>

          {/* 4 Compact Icon Cards */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 pt-4">
            <div className="bg-white/5 border border-white/10 rounded-xl p-3 flex items-start gap-3 hover:bg-white/10 transition-colors">
              <div className="w-8 h-8 rounded-lg bg-amber-400/20 text-amber-300 flex items-center justify-center shrink-0">
                <Zap className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-xs font-bold text-white">Milk Protein</h3>
                <p className="text-[11px] text-slate-300">Healthy weight & lean muscle</p>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 flex items-start gap-3 hover:bg-white/10 transition-colors">
              <div className="w-8 h-8 rounded-lg bg-emerald-400/20 text-emerald-300 flex items-center justify-center shrink-0">
                <Sparkles className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-xs font-bold text-white">Vitamins A to E</h3>
                <p className="text-[11px] text-slate-300">Immunity & all-day stamina</p>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 flex items-start gap-3 hover:bg-white/10 transition-colors">
              <div className="w-8 h-8 rounded-lg bg-sky-400/20 text-sky-300 flex items-center justify-center shrink-0">
                <HeartPulse className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-xs font-bold text-white">Zinc & Magnesium</h3>
                <p className="text-[11px] text-slate-300">Boosts appetite & digestion</p>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 flex items-start gap-3 hover:bg-white/10 transition-colors">
              <div className="w-8 h-8 rounded-lg bg-rose-400/20 text-rose-300 flex items-center justify-center shrink-0">
                <ShieldCheck className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-xs font-bold text-white">Calcium & Minerals</h3>
                <p className="text-[11px] text-slate-300">Bone density & recovery</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};


